const cards = [
  {
    title: '本周最热：高分动作片连播',
    desc: '精选十部豆瓣8分以上动作大片，高清画质连播不停歇。从经典港片到好莱坞巨制，燃爆你的周末。',
    tag: '热门推荐',
    img: 'https://readdy.ai/api/search-image?query=Intense%20action%20film%20poster%20style%20composition%20with%20warm%20golden%20and%20crimson%20lighting%2C%20dramatic%20cinematic%20atmosphere%2C%20abstract%20dynamic%20energy%2C%20rich%20contrast%2C%20movie%20theater%20vibe%2C%20no%20text%2C%20no%20faces&width=600&height=400&seq=card-01-hot-action&orientation=landscape',
  },
  {
    title: '新剧速递：多部热剧同步更新',
    desc: '近期高分新剧全集已上线，高清资源同步海外更新，第一时间追到最新剧情。',
    tag: '最新上线',
    img: 'https://readdy.ai/api/search-image?query=Elegant%20modern%20TV%20series%20atmosphere%20with%20warm%20ambient%20lighting%2C%20cinematic%20composition%2C%20soft%20bokeh%20background%2C%20amber%20and%20gold%20tones%2C%20premium%20film%20aesthetic%2C%20no%20text%2C%20no%20people&width=600&height=400&seq=card-02-new-shows&orientation=landscape',
  },
  {
    title: '经典重温：港片黄金年代',
    desc: '回顾90年代香港电影黄金时期，周星驰喜剧、成龙动作、王家卫文艺，高清修复版经典再现。',
    tag: '经典回顾',
    img: 'https://readdy.ai/api/search-image?query=Nostalgic%20classic%20film%20atmosphere%20with%20warm%20vintage%20tones%2C%20old%20cinema%20projector%20light%20beam%2C%20film%20grain%20texture%2C%20golden%20amber%20glow%2C%20retro%20movie%20theater%20vibe%2C%20no%20text%2C%20no%20people&width=600&height=400&seq=card-03-classic&orientation=landscape',
  },
  {
    title: '悬疑之夜：烧脑佳作合集',
    desc: '精选国内外高分悬疑电影，反转不断的精彩剧情让你欲罢不能。适合喜欢动脑筋的观众。',
    tag: '悬疑专场',
    img: 'https://readdy.ai/api/search-image?query=Mysterious%20dark%20cinematic%20scene%20with%20single%20warm%20amber%20light%20source%2C%20deep%20shadows%2C%20film%20noir%20style%2C%20suspenseful%20composition%2C%20rich%20contrast%2C%20elegant%20moody%20atmosphere%2C%20no%20text%2C%20no%20people&width=600&height=400&seq=card-04-suspense&orientation=landscape',
  },
  {
    title: '科幻盛宴：视觉奇观影单',
    desc: '从星际穿越到流浪地球，震撼视觉科幻大片高清合集，在家也能享受影院级体验。',
    tag: '科幻巨制',
    img: 'https://readdy.ai/api/search-image?query=Futuristic%20cinematic%20atmosphere%20with%20warm%20golden%20nebula%20light%2C%20abstract%20cosmic%20composition%2C%20sci-fi%20movie%20poster%20style%2C%20deep%20space%20with%20amber%20highlights%2C%20no%20text%2C%20no%20people%2C%20rich%20dramatic%20lighting&width=600&height=400&seq=card-05-scifi&orientation=landscape',
  },
  {
    title: '温情治愈：暖心电影推荐',
    desc: '那些让你感动落泪的温情电影，适合一个人静静观看。关于爱、成长与希望的故事。',
    tag: '治愈精选',
    img: 'https://readdy.ai/api/search-image?query=Warm%20gentle%20cinematic%20scene%20with%20soft%20golden%20sunlight%2C%20cozy%20atmosphere%2C%20dreamy%20bokeh%20lights%2C%20film%20poster%20aesthetic%2C%20amber%20and%20rose%20tones%2C%20emotional%20warmth%2C%20no%20text%2C%20no%20people&width=600&height=400&seq=card-06-heartwarming&orientation=landscape',
  },
  {
    title: '动漫专区：热血番剧精选',
    desc: '人气动漫高清合集，从经典老番到当季新番，二次元爱好者不可错过的片单。',
    tag: '动漫推荐',
    img: 'https://readdy.ai/api/search-image?query=Vibrant%20anime%20style%20cinematic%20atmosphere%20with%20warm%20colorful%20lighting%2C%20dynamic%20composition%2C%20Japanese%20animation%20aesthetic%2C%20golden%20amber%20accents%2C%20rich%20visual%20energy%2C%20no%20text%2C%20no%20people&width=600&height=400&seq=card-07-anime&orientation=landscape',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-3">
              热播资讯
            </h2>
            <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
              最新影视资讯与精选片单，发现你的下一部心头好
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
            {cards.slice(0, 6).map((card, i) => (
              <div
                key={i}
                className="group bg-background-100 rounded-xl overflow-hidden border border-background-200/70 hover:border-accent-300/40 transition-all cursor-pointer"
              >
                <div className="relative aspect-[3/2] overflow-hidden">
                  <img
                    src={card.img}
                    alt={card.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute top-3 left-3">
                    <span className="px-2.5 py-1 text-xs font-medium bg-accent-500/90 text-background-50 rounded-full whitespace-nowrap">
                      {card.tag}
                    </span>
                  </div>
                </div>
                <div className="p-4 md:p-5">
                  <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-2 group-hover:text-accent-600 transition-colors">
                    {card.title}
                  </h3>
                  <p className="text-xs md:text-sm text-foreground-500 leading-relaxed line-clamp-2">
                    {card.desc}
                  </p>
                </div>
              </div>
            ))}
            <div className="lg:col-span-3">
              <div className="bg-background-100 rounded-xl border border-background-200/70 p-5 md:p-6">
                <div className="flex items-start gap-4">
                  <div className="w-24 md:w-28 h-16 md:h-18 rounded-lg overflow-hidden flex-shrink-0">
                    <img
                      src={cards[6].img}
                      alt={cards[6].title}
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <div className="flex-1 min-w-0">
                    <span className="inline-block px-2 py-0.5 text-xs font-medium bg-accent-100 text-accent-700 rounded-full mb-2 whitespace-nowrap">
                      {cards[6].tag}
                    </span>
                    <h3 className="text-sm font-semibold text-foreground-900 mb-1">{cards[6].title}</h3>
                    <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">{cards[6].desc}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}